module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "listing-wrapper"
    }
  }, [_c('script', {
    attrs: {
      "type": "application/ld+json"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.displaySchemaImage()) + "\n  ")]), _vm._v(" "), _c('script', {
    attrs: {
      "type": "application/ld+json"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.displaySchemaBreadcrumb()) + "\n  ")]), _vm._v(" "), (this.$route.query.page && this.$route.query.page > 1) ? _c('link', {
    attrs: {
      "rel": "prev",
      "href": _vm.prevUrl
    }
  }) : _vm._e(), _vm._v(" "), (this.$route.query.page !== _vm.pagination.totalPages) ? _c('link', {
    attrs: {
      "rel": "next",
      "href": _vm.nextUrl
    }
  }) : _vm._e(), _vm._v(" "), _c('link', {
    attrs: {
      "rel": "canonical",
      "href": _vm.canonicalUrl
    }
  }), _vm._v(" "), (_vm.isSelectedCountryIndia && _vm.bannerPlaceHolderForExc && _vm.bannerPlaceHolderForExc.status && (_vm.isExclusive || _vm.exclusiveUser)) ? _c('ExclusiveSavingsInfo', {
    attrs: {
      "isExclusive": _vm.isExclusive || _vm.exclusiveUser,
      "calculations": _vm.calculations,
      "bannerStyle": _vm.bannerPlaceHolderForExc && _vm.bannerPlaceHolderForExc.styles,
      "bannerMsg": _vm.bannerPlaceHolderForExc && _vm.bannerPlaceHolderForExc.text
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isSelectedCountryIndia && _vm.bannerPlaceHolderForNonExc && _vm.bannerPlaceHolderForNonExc.status && (!_vm.isExclusive || !_vm.exclusiveUser)) ? _c('BannerPlaceHolderMsg', {
    attrs: {
      "bannerStyle": _vm.bannerPlaceHolderForNonExc && _vm.bannerPlaceHolderForNonExc.styles,
      "bannerMsg": _vm.bannerPlaceHolderForNonExc && _vm.bannerPlaceHolderForNonExc.text
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "listing"
  }, [_c('div', {
    staticClass: "main-banner-area"
  }, [(!this.$parent.isDesktop && _vm.listingType && _vm.anyTwoGenderKeysTrue()) ? _c('GenderTabs', {
    attrs: {
      "callerComp": 'listing',
      "tabsCountDataArr": _vm.tabsCountData
    },
    on: {
      "updateLandingCategory": function($event) {
        _vm.getLandingProducts($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isExclusive && _vm.productCategory !== 'reward-points-offer' && _vm.bannerPlaceHolderForExclusive && _vm.bannerPlaceHolderForExclusive.text && _vm.bannerPlaceHolderForExclusive.status) ? _c('div', {
    staticClass: "text-center exclusive-bar",
    style: (_vm.bannerPlaceHolderForExclusive.styles)
  }, [_c('span', {
    staticStyle: {
      "font-size": "17px"
    }
  }, [_c('div', {
    staticClass: "customcheckbox mr-15 pointer",
    staticStyle: {
      "text-transform": "unset"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "giftwrap",
      "id": "giftwrap"
    },
    domProps: {
      "checked": _vm.isNotifyVisible
    },
    on: {
      "click": function($event) {
        _vm.addExclusiveToCartFromBand(_vm.EXCLUSIVE_PRODUCTS[2].prod_id)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mb0",
    attrs: {
      "for": ""
    }
  }, [_vm._v(_vm._s(_vm.bannerPlaceHolderForExclusive.text))])])])]) : _vm._e(), _vm._v(" "), (this.$refs && this.$refs.filterOptions && this.$refs.filterOptions.sneakerOptions && !this.$parent.isDesktop) ? _c('sneakrFilterOption', {
    ref: "filterSneakerOptions",
    attrs: {
      "sneakerOptions": _vm.sneakerdata
    }
  }) : _vm._e(), _vm._v(" "), (this.$route.path !== '/artists/starwars-official-merchandise' && this.$route.path !== '/batman' && !_vm.notFound) ? _c('div', {
    class: [{
      'minHeight': _vm.setMinHeight
    }, 'shimmerBgColor']
  }, [(_vm.bannersVedio && _vm.bannersVedio.show_video_url && _vm.bannersVedio.video_url) ? _c('div', {
    staticClass: "mweb-vedio-height"
  }, [_c('VideoPlayer', {
    attrs: {
      "src": _vm.$parent.isDesktop ? _vm.bannersVedio.video_url : _vm.bannersVedio.mobile_video_url,
      "poster": _vm.$parent.isDesktop ? _vm.bannersVedio.video_thumbnail : _vm.bannersVedio.mobile_video_thumbnail,
      "playVideo": true
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.$parent.isDesktop) ? _c('carousel', {
    attrs: {
      "perPage": 1,
      "navigationEnabled": true,
      "paginationEnabled": false,
      "navigationNextLabel": " ",
      "navigationPrevLabel": " ",
      "autoplay": true
    }
  }, _vm._l((_vm.banners.desktop), function(bannerImage, index1) {
    return _c('slide', {
      key: index1
    }, [(_vm.navLink) ? _c('a', {
      directives: [{
        name: "bannerImageLoad",
        rawName: "v-bannerImageLoad",
        value: (_vm.getBannerImpressionData(index1)),
        expression: "getBannerImpressionData(index1)"
      }],
      staticClass: "pointer d-inline-block w-100",
      attrs: {
        "href": _vm.navLink
      }
    }, [_c('img', {
      staticClass: "customFade img-auto",
      attrs: {
        "data-url": bannerImage,
        "alt": _vm.listingBannerAlt,
        "width": "1500",
        "height": "385"
      },
      on: {
        "click": function($event) {
          _vm.bannerClick(index1)
        }
      }
    })]) : _c('div', {
      directives: [{
        name: "bannerImageLoad",
        rawName: "v-bannerImageLoad",
        value: (_vm.getBannerImpressionData(index1)),
        expression: "getBannerImpressionData(index1)"
      }]
    }, [_c('img', {
      staticClass: "customFade img-auto",
      attrs: {
        "data-url": bannerImage,
        "alt": _vm.listingBannerAlt,
        "width": "1500",
        "height": "385"
      }
    })])])
  })) : _c('carousel', {
    attrs: {
      "perPage": 1,
      "navigationEnabled": true,
      "paginationEnabled": false,
      "navigationNextLabel": " ",
      "navigationPrevLabel": " ",
      "autoplay": true
    }
  }, _vm._l((_vm.banners.mobile), function(bannerImage, index2) {
    return _c('slide', {
      key: index2
    }, [_c('div', {
      staticClass: "minHeight shimmerBgColor"
    }, [(_vm.navLink) ? _c('a', {
      directives: [{
        name: "bannerImageLoad",
        rawName: "v-bannerImageLoad",
        value: (_vm.getBannerImpressionData(index2)),
        expression: "getBannerImpressionData(index2)"
      }],
      attrs: {
        "href": _vm.navLink
      }
    }, [_c('img', {
      staticClass: "customFade img-auto",
      attrs: {
        "data-url": bannerImage,
        "alt": _vm.listingBannerAlt,
        "width": "768",
        "height": "600"
      },
      on: {
        "click": function($event) {
          _vm.bannerClick(index2)
        }
      }
    })]) : _c('div', {
      directives: [{
        name: "bannerImageLoad",
        rawName: "v-bannerImageLoad",
        value: (_vm.getBannerImpressionData(index2)),
        expression: "getBannerImpressionData(index2)"
      }]
    }, [_c('img', {
      staticClass: "customFade img-auto",
      attrs: {
        "data-url": bannerImage,
        "alt": _vm.listingBannerAlt,
        "width": "768",
        "height": "600"
      }
    })])])])
  }))], 1) : _vm._e(), _vm._v(" "), (this.$route.path === '/artists/starwars-official-merchandise' && _vm.theme === 'dark-mode') ? _c('div', [_c('picture', [_c('source', {
    attrs: {
      "media": "(max-width: 575px)",
      "srcset": "https://prod-img.thesouledstore.com/static/star-wars/starwars_banner_movile.jpg"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "media": "(min-width: 576px)",
      "srcset": "https://prod-img.thesouledstore.com/static/star-wars/starwars-darkside-website.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "w-100",
    attrs: {
      "data-src": "https://prod-img.thesouledstore.com/static/star-wars/starwars-darkside-website.jpg",
      "alt": "Star war official merchandise"
    }
  })])], 1) : _vm._e(), _vm._v(" "), (this.$route.path === '/artists/starwars-official-merchandise' && _vm.theme === 'light-mode') ? _c('div', [_c('picture', [_c('source', {
    attrs: {
      "media": "(max-width: 575px)",
      "srcset": "https://prod-img.thesouledstore.com/static/star-wars/starwars-lightside-mobile.jpg"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "media": "(min-width: 576px)",
      "srcset": "https://prod-img.thesouledstore.com/static/star-wars/starwars-lightside-website.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "w-100",
    attrs: {
      "data-src": "https://prod-img.thesouledstore.com/static/star-wars/starwars-lightside-website.jpg",
      "alt": "Star war official merchandise"
    }
  })])], 1) : _vm._e(), _vm._v(" "), (this.$route.path === '/batman' && _vm.theme === 'dark-mode-batman') ? _c('div', [(this.$parent.isDesktop) ? _c('carousel', {
    attrs: {
      "perPage": 1,
      "navigationEnabled": true,
      "paginationEnabled": false,
      "navigationNextLabel": " ",
      "navigationPrevLabel": " ",
      "autoplay": true
    }
  }, _vm._l((_vm.banners.desktop), function(bannerImage, index1) {
    return _c('slide', {
      key: index1
    }, [(_vm.navLink) ? _c('a', {
      directives: [{
        name: "bannerImageLoad",
        rawName: "v-bannerImageLoad",
        value: (_vm.getBannerImpressionData(index1)),
        expression: "getBannerImpressionData(index1)"
      }],
      staticClass: "pointer d-inline-block w-100",
      attrs: {
        "href": _vm.navLink
      }
    }, [_c('img', {
      staticClass: "customFade img-auto",
      attrs: {
        "data-url": bannerImage,
        "alt": _vm.listingBannerAlt,
        "width": "1500",
        "height": "385"
      },
      on: {
        "click": function($event) {
          _vm.bannerClick(index1)
        }
      }
    })]) : _c('div', {
      directives: [{
        name: "bannerImageLoad",
        rawName: "v-bannerImageLoad",
        value: (_vm.getBannerImpressionData(index1)),
        expression: "getBannerImpressionData(index1)"
      }]
    }, [_c('img', {
      staticClass: "customFade img-auto",
      attrs: {
        "data-url": bannerImage,
        "alt": _vm.listingBannerAlt,
        "width": "1500",
        "height": "385"
      }
    })])])
  })) : _c('carousel', {
    attrs: {
      "perPage": 1,
      "navigationEnabled": true,
      "paginationEnabled": false,
      "navigationNextLabel": " ",
      "navigationPrevLabel": " ",
      "autoplay": true
    }
  }, _vm._l((_vm.banners.mobile), function(bannerImage, index2) {
    return _c('slide', {
      key: index2
    }, [_c('div', {
      staticClass: "minHeight shimmerBgColor"
    }, [(_vm.navLink) ? _c('a', {
      directives: [{
        name: "bannerImageLoad",
        rawName: "v-bannerImageLoad",
        value: (_vm.getBannerImpressionData(index2)),
        expression: "getBannerImpressionData(index2)"
      }],
      attrs: {
        "href": _vm.navLink
      }
    }, [_c('img', {
      staticClass: "customFade img-auto",
      attrs: {
        "data-url": bannerImage,
        "alt": _vm.listingBannerAlt,
        "width": "768",
        "height": "600"
      },
      on: {
        "click": function($event) {
          _vm.bannerClick(index2)
        }
      }
    })]) : _c('div', {
      directives: [{
        name: "bannerImageLoad",
        rawName: "v-bannerImageLoad",
        value: (_vm.getBannerImpressionData(index2)),
        expression: "getBannerImpressionData(index2)"
      }]
    }, [_c('img', {
      staticClass: "customFade img-auto",
      attrs: {
        "data-url": bannerImage,
        "alt": _vm.listingBannerAlt,
        "width": "768",
        "height": "600"
      }
    })])])])
  }))], 1) : _vm._e(), _vm._v(" "), (this.$route.path === '/batman' && _vm.theme === 'light-mode-batman') ? _c('div', [(this.$parent.isDesktop) ? _c('carousel', {
    attrs: {
      "perPage": 1,
      "navigationEnabled": true,
      "paginationEnabled": false,
      "navigationNextLabel": " ",
      "navigationPrevLabel": " ",
      "autoplay": true
    }
  }, _vm._l((_vm.banners.desktop), function(bannerImage, index1) {
    return _c('slide', {
      key: index1
    }, [(_vm.navLink) ? _c('a', {
      directives: [{
        name: "bannerImageLoad",
        rawName: "v-bannerImageLoad",
        value: (_vm.getBannerImpressionData(index1)),
        expression: "getBannerImpressionData(index1)"
      }],
      staticClass: "pointer d-inline-block w-100",
      attrs: {
        "href": _vm.navLink
      }
    }, [_c('img', {
      staticClass: "customFade img-auto",
      attrs: {
        "data-url": bannerImage,
        "alt": _vm.listingBannerAlt,
        "width": "1500",
        "height": "385"
      },
      on: {
        "click": function($event) {
          _vm.bannerClick(index1)
        }
      }
    })]) : _c('div', {
      directives: [{
        name: "bannerImageLoad",
        rawName: "v-bannerImageLoad",
        value: (_vm.getBannerImpressionData(index1)),
        expression: "getBannerImpressionData(index1)"
      }]
    }, [_c('img', {
      staticClass: "customFade img-auto",
      attrs: {
        "data-url": bannerImage,
        "alt": _vm.listingBannerAlt,
        "width": "1500",
        "height": "385"
      }
    })])])
  })) : _c('carousel', {
    attrs: {
      "perPage": 1,
      "navigationEnabled": true,
      "paginationEnabled": false,
      "navigationNextLabel": " ",
      "navigationPrevLabel": " ",
      "autoplay": true
    }
  }, _vm._l((_vm.banners.mobile), function(bannerImage, index2) {
    return _c('slide', {
      key: index2
    }, [_c('div', {
      staticClass: "minHeight shimmerBgColor"
    }, [(_vm.navLink) ? _c('a', {
      directives: [{
        name: "bannerImageLoad",
        rawName: "v-bannerImageLoad",
        value: (_vm.getBannerImpressionData(index2)),
        expression: "getBannerImpressionData(index2)"
      }],
      attrs: {
        "href": _vm.navLink
      }
    }, [_c('img', {
      staticClass: "customFade img-auto",
      attrs: {
        "data-url": bannerImage,
        "alt": _vm.listingBannerAlt,
        "width": "768",
        "height": "600"
      },
      on: {
        "click": function($event) {
          _vm.bannerClick(index2)
        }
      }
    })]) : _c('div', {
      directives: [{
        name: "bannerImageLoad",
        rawName: "v-bannerImageLoad",
        value: (_vm.getBannerImpressionData(index2)),
        expression: "getBannerImpressionData(index2)"
      }]
    }, [_c('img', {
      staticClass: "customFade img-auto",
      attrs: {
        "data-url": bannerImage,
        "alt": _vm.listingBannerAlt,
        "width": "768",
        "height": "600"
      }
    })])])])
  }))], 1) : (_vm.$route.params.sid === 'scarves' && !_vm.isExclusive) ? _c('div', {
    staticClass: "text-center exclusive-bar"
  }, [_c('span', {
    staticStyle: {
      "font-size": "17px"
    }
  }, [_c('div', {
    staticClass: "customcheckbox mr-15 pointer",
    staticStyle: {
      "text-transform": "unset"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "giftwrap",
      "id": "giftwrap"
    },
    on: {
      "click": function($event) {
        _vm.addExclusive(_vm.EXCLUSIVE_PRODUCTS[2].prod_id)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mb0",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Become a member to buy these scarves now")])])])]) : _vm._e(), _vm._v(" "), (_vm.bannerPlaceHolderForAPPCashBack &&
    _vm.bannerPlaceHolderForAPPCashBack.text && _vm.bannerPlaceHolderForAPPCashBack.status && this.allProducts.length > 0) ? _c('BannerPlaceHolderMsg', {
    attrs: {
      "bannerStyle": _vm.bannerPlaceHolderForAPPCashBack && _vm.bannerPlaceHolderForAPPCashBack.styles,
      "bannerMsg": _vm.bannerPlaceHolderForAPPCashBack && _vm.bannerPlaceHolderForAPPCashBack.text,
      "toggleCashbackPopup": _vm.bannerPlaceHolderForAPPCashBack && _vm.bannerPlaceHolderForAPPCashBack.text && _vm.bannerPlaceHolderForAPPCashBack.text.toLowerCase() && _vm.bannerPlaceHolderForAPPCashBack.text.toLowerCase().includes('cashback') && _vm.toggleCashbackPopup
    }
  }) : _vm._e(), _vm._v(" "), (_vm.timerData && _vm.timerData.showCountDown && _vm.saleDet && !_vm.saleDet.enable_daily_drop_web) ? _c('CountdownPLP', {
    attrs: {
      "starttime": _vm.timerData.startDate,
      "endtime": _vm.timerData.endDate,
      "color": _vm.timerData.timerColor,
      "showTimer": _vm.timerData.showTimer,
      "pretext": _vm.timerData.liveSaleText,
      "showEarlyText": _vm.timerData.showEarlyText,
      "days": _vm.timerData.days,
      "minutes": _vm.timerData.minutes,
      "hours": _vm.timerData.hours,
      "seconds": _vm.timerData.seconds,
      "now": _vm.timerData.now,
      "mobileUI": _vm.$parent.isDesktop ? false : true
    },
    on: {
      "getLiveSaleText": _vm.getSaleTextToShow
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "container plisting fullWidth"
  }, [(_vm.notFound) ? _c('div', [_c('NoProductFoundListing', {
    attrs: {
      "wishlistItemsIDs": _vm.wishlistItemsIDs,
      "updateWishlist": _vm.updateWishlist
    }
  })], 1) : _c('div', {
    staticClass: "container plisting fullWidth p-0",
    class: [_vm.categoriesCard.includes(_vm.$route.params.sid) ? 'no-gutters' : '']
  }, [(this.$route.path === '/artists/starwars-official-merchandise') ? _c('div', [_c('div', {
    staticClass: "lined-header mt-3 mb-1"
  }, [_c('h2', [_vm._v("Choose Your Side")])]), _vm._v(" "), _c('img', {
    staticClass: "d-block m-auto",
    attrs: {
      "data-src": "https://prod-img.thesouledstore.com/static/star-wars/BUTTON.png",
      "usemap": "#theme-map",
      "alt": "Choose your side"
    }
  }), _vm._v(" "), _c('map', {
    attrs: {
      "name": "theme-map"
    }
  }, [_c('area', {
    attrs: {
      "alt": "dark side",
      "coords": "6,10,194,49",
      "shape": "rect"
    },
    on: {
      "click": _vm.activateDarkTheme
    }
  }), _vm._v(" "), _c('area', {
    attrs: {
      "alt": "light side",
      "coords": "395,10,201,48",
      "shape": "rect"
    },
    on: {
      "click": _vm.activateLightTheme
    }
  })])]) : _vm._e(), _vm._v(" "), (this.$route.path === '/batman') ? _c('div', [_c('div', {
    staticClass: "lined-header-batman mt-3 mb-1"
  }, [_c('h2', [_vm._v("Welcome to Gotham")])]), _vm._v(" "), (this.$route.path === '/batman') ? _c('div', {
    staticClass: "m-auto theme-selector-container"
  }, [_c('img', {
    staticClass: "d-block m-auto dark-light-toggle",
    attrs: {
      "data-src": "https://prod-img.thesouledstore.com/public/theSoul/uploads/dark-light-4k.png",
      "alt": "Choose your side"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "click-area light-area",
    on: {
      "click": _vm.activateLightTheme
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "click-area dark-area",
    on: {
      "click": _vm.activateDarkTheme
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "d-flex justify-content-end "
  }, [_c('div', {
    staticClass: "col-lg-9 col-md-8  pro-list"
  }, [(_vm.$parent.isDesktop) ? _c('div', {
    staticClass: "breadcrumbcustome"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-12"
  }, [_c('div', {
    staticClass: "newbread"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Home")]), _vm._v(" "), (this.formattedArtistName) ? _c('span', [_vm._v(" / "), _c('router-link', {
    attrs: {
      "to": this.formattedArtistSlug
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.formattedArtistName)
    }
  })])], 1) : _vm._e(), _vm._v("\n                    / "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.formattedArtist)
    }
  }), _vm._v(" "), (false) ? _c('span', [_c('br'), _vm._v("\n                      (\n                      "), _c('u', [_c('router-link', {
    attrs: {
      "to": "/mobile-covers"
    }
  }, [_vm._v("Change phone model")])], 1), _vm._v("\n                      )\n                    ")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-between align-items-end align-items-lg-center"
  }, [_c('header', {
    staticClass: "col-lg-6 col-md-6 col-12 header-title-wrapper"
  }, [(_vm.formattedHeader) ? _c('h1', {
    ref: "listingHeader",
    staticClass: "list-header"
  }, [_vm._v("\n                  " + _vm._s(_vm.formattedHeader) + "\n                ")]) : _vm._e(), _vm._v(" "), (this.pagination && this.pagination.totalProduct) ? _c('span', {
    class: ['title-count', {
      'desktop': this.$parent.isDesktop
    }]
  }, [_vm._v("\n                  - " + _vm._s(this.pagination.totalProduct) + " items\n                ")]) : _vm._e()]), _vm._v(" "), _c('sorting-options', {
    staticClass: "w-full",
    staticStyle: {
      "max-width": "235px"
    },
    attrs: {
      "sortingOptionsData": _vm.sortingOptionsData,
      "sortData": this.$refs && this.$refs.filterOptions && this.$refs.filterOptions.sorts
    }
  })], 1), _vm._v(" "), (this.$parent.isDesktop) ? _c('div', {
    staticClass: "row filter-chips-wrap pt-2"
  }, _vm._l((this.$refs.filterOptions && this.$refs.filterOptions.getSelectedFilterChips), function(item, index3) {
    return _c('div', {
      key: index3,
      staticClass: "filter-chip-card px-2 m-1"
    }, [_c('span', {
      staticClass: "p-1"
    }, [_vm._v("\n                    " + _vm._s(['gender', 'size', 'stock', 'sort'].includes(item.alias.toLowerCase()) ? ((item.alias) + " : ") : '') + "\n                    " + _vm._s(item.name) + "\n                    "), _c('svg', {
      staticClass: "pointer",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "id": "CloseIcon",
        "width": "18",
        "height": "18",
        "viewBox": "0 0 24 15"
      },
      on: {
        "click": function($event) {
          _vm.removeFilterChipHandler(item)
        }
      }
    }, [_c('path', {
      staticClass: "cls-close",
      attrs: {
        "id": "Line_9",
        "d": "M12 0L0 12",
        "transform": "translate(6 6)"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "cls-close",
      attrs: {
        "id": "Line_10",
        "d": "M0 0L12 12",
        "transform": "translate(6 6)"
      }
    })])])])
  })) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3 col-md-4 col-12 filterCol"
  }, [(_vm.profilePhoto && this.$parent.isDesktop) ? _c('div', [(this.$route.path === '/artists/starwars-official-merchandise') ? _c('div', {
    staticClass: "artUsericon text-center"
  }, [(_vm.theme === 'light-mode') ? _c('img', {
    attrs: {
      "data-src": "https://prod-img.thesouledstore.com/static/star-wars/Light_artistimage.jpg",
      "alt": "Star War Artist"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.theme === 'dark-mode') ? _c('img', {
    attrs: {
      "data-src": "https://prod-img.thesouledstore.com/static/star-wars/Dark_artistimage.jpg",
      "alt": "Star War Artist"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (this.$route.path === '/batman') ? _c('div', {
    staticClass: "artUsericon text-center"
  }, [(_vm.theme === 'light-mode-batman') ? _c('img', {
    attrs: {
      "data-src": "https://tss-static-images.gumlet.io/star-wars/Light_artistimage.jpg",
      "alt": "Star War Artist"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.theme === 'dark-mode-batman') ? _c('img', {
    attrs: {
      "data-src": "https://tss-static-images.gumlet.io/star-wars/Dark_artistimage.jpg",
      "alt": "Star War Artist"
    }
  }) : _vm._e()]) : _c('div', {
    staticClass: "artUsericon text-center"
  }, [_c('img', {
    staticClass: "img-auto",
    attrs: {
      "data-src": _vm.profilePic,
      "alt": "Profile",
      "width": "252",
      "height": "252"
    }
  })]), _vm._v(" "), (_vm.isArtistListing) ? _c('div', {
    staticClass: "artistCont"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12 col-12"
  }, [_c('h4', {
    staticClass: "hsubnav f18 text-inherit mb-0"
  }, [_vm._v(_vm._s(_vm.artistData.firstname.replace('\u0099', '™')) + " " + _vm._s(_vm.artistData.lastname))])])]), _vm._v(" "), (_vm.artistData.is_merch === 0) ? _c('div', {
    staticClass: "accordiontabs mt10",
    attrs: {
      "id": "artistinfo",
      "role": "tablist",
      "aria-multiselectable": "false"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "role": "tab",
      "id": "artione"
    }
  }, [_c('h5', {
    staticClass: "mb-0 flighter"
  }, [_c('a', {
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#artistinfo",
      "href": "#infoone",
      "aria-expanded": "false",
      "aria-controls": "collapseOne"
    }
  }, [_vm._v("\n                      Artist Info\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "infoone",
      "role": "tabpanel",
      "aria-labelledby": "artione"
    }
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.artistData.description)
    }
  })])])])]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('filter-options', {
    ref: "filterOptions",
    attrs: {
      "isKids": _vm.webcategory === 'kids' ? true : false
    },
    on: {
      "filterClick": _vm.filterListing,
      "updateSortingOptions": function($event) {
        _vm.updateSortingOptionsHandler($event)
      },
      "clearClick": _vm.clearFilters
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 col-md-8 col-12 pro-list"
  }, [_c('div', [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.loading && _vm.mobileCurrentPage === 1) ? _c('div', {
    staticClass: "spinner-3-wrapper"
  }, [_c('img', {
    staticClass: "spinner-3",
    attrs: {
      "src": _vm.staticImgServer + 'assets/spinner-3.gif',
      "alt": "Loader"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "loading-txt"
  }, [_vm._v("Awesomeness Loading")])]) : (_vm.productsListing.length) ? _c('div', {
    staticClass: "row",
    class: [_vm.categoriesCard.includes(_vm.$route.params.sid) ? 'no-gutters p-0' : '', _vm.isCarouselImageLoaded && _vm.isPlpFirstTimeVisited ? 'animate-container' : '']
  }, [_c('div', {
    ref: "scrollSentinelTop",
    staticStyle: {
      "height": "1px",
      "width": "100%"
    }
  }), _vm._v(" "), _vm._l((_vm.productsListing), function(prm, index4) {
    return _c('div', {
      key: index4,
      class: [prm.tiptiles && prm.tiptiles.type === 'TYPE2' ? prm.tiptiles.colWidth && _vm.$parent.isDesktop ? ("col-" + (prm.tiptiles.colWidth)) : 'col-12' : 'col-lg-3 col-md-6 col-6 animate-card', prm.tiptiles ? 'd-flex flex-column' : '']
    }, [(_vm.categoriesCard.includes(_vm.$route.params.sid)) ? _c('ProductCard', {
      attrs: {
        "image": prm.tiptiles ? _vm.$parent.isDesktop ? prm.tiptiles.image : prm.tiptiles.mobileImage : prm.images[0],
        "secondaryImage": prm.images && prm.images[1],
        "alt": "",
        "slug": prm.product_slug,
        "name": prm.tiptiles ? prm.tiptiles.name : prm.product,
        "price": prm.price,
        "splPrice": prm.splPrice || prm.spl_price,
        "category": prm.category && prm.category.name,
        "pstock": prm.stock,
        "isStockConfig": prm.prodQty,
        "prodType": prm.prodType,
        "scrollToProduct": _vm.scrollNow,
        "isExclusive": _vm.isExclusive,
        "exclusivePrice": prm.exclusivePrice,
        "product": prm,
        "plpMockUpTags": _vm.plpMockUpTags,
        "showImageBlurSoldOutDesign": true
      },
      nativeOn: {
        "click": function($event) {
          _vm.productClick({
            prm: prm,
            index4: index4
          })
        }
      }
    }) : (prm && prm.plpCoverImage && prm.isProductLocked) ? _c('img-block', {
      attrs: {
        "parry": prm.plpCoverImage ? [prm.plpCoverImage] : prm.images,
        "position": index4,
        "imageH": 400,
        "imageW": 300,
        "avgRating": prm.avgRating,
        "bannerplprating": _vm.bannerPLPRating,
        "ratingCount": prm.ratingCount,
        "urlKey": prm.product_slug,
        "productTitle": prm.tiptiles ? prm.tiptiles.name : prm.product,
        "productCat": prm.artist && prm.artist.name,
        "productPrice": prm.price,
        "exclusivePrice": prm.exclusivePrice,
        "jitValue": prm.jitValue,
        "pstock": prm.stock,
        "spprice": prm.splPrice || prm.spl_price,
        "listCat": prm.category && prm.category.name,
        "pclass": 'prd' + prm.id + prm.category + 'img',
        "product": prm,
        "isStockConfig": prm.prodQty,
        "scrollToProduct": _vm.scrollNow,
        "prodType": prm.prodType,
        "togglePopup": _vm.togglePopup,
        "imageCount": _vm.productsListing.length,
        "plpMockUpTags": _vm.plpMockUpTags,
        "genderType": prm.genderType,
        "showImageBlurSoldOutDesign": true,
        "timerData": _vm.timerData && _vm.timerData.showCountDown && _vm.saleDet && _vm.saleDet.enable_daily_drop_web ? _vm.timerData : null,
        "gstInClusiveLabel": _vm.bannerPlaceHolderForGstInclusiveLabel,
        "prm": prm,
        "wishlistItemsIDs": _vm.wishlistItemsIDs,
        "updateWishlist": _vm.updateWishlist,
        "hideWishlist": _vm.hideWishlist,
        "saleDet": _vm.saleDet,
        "callerComp": "PLP Page",
        "headingTitle": _vm.headingTitle
      },
      on: {
        "carousel-images-loaded": _vm.handleCarouselImagesLoaded
      },
      nativeOn: {
        "click": function($event) {
          _vm.productClick({
            prm: prm,
            index4: index4
          })
        }
      }
    }) : _c('img-block', {
      attrs: {
        "size": prm.size ? prm.size : '',
        "parry": prm.tiptiles ? _vm.$parent.isDesktop ? [prm.tiptiles.image] : [prm.tiptiles.mobileImage] : prm.images,
        "position": index4,
        "imageH": 400,
        "imageW": 300,
        "avgRating": prm.avgRating,
        "bannerplprating": _vm.bannerPLPRating,
        "ratingCount": prm.ratingCount,
        "urlKey": prm.product_slug,
        "productTitle": prm.tiptiles ? prm.tiptiles.name : prm.product,
        "productCat": prm.artist && prm.artist.name,
        "productPrice": prm.price,
        "exclusivePrice": prm.exclusivePrice,
        "jitValue": prm.jitValue,
        "pstock": prm.stock,
        "spprice": prm.splPrice || prm.spl_price,
        "listCat": prm.category && prm.category.name,
        "pclass": 'prd' + prm.id + prm.category + 'img',
        "product": prm,
        "isStockConfig": prm.prodQty,
        "scrollToProduct": _vm.scrollNow,
        "prodType": prm.prodType,
        "togglePopup": _vm.togglePopup,
        "imageCount": _vm.productsListing.length,
        "plpMockUpTags": _vm.plpMockUpTags,
        "genderType": prm.genderType,
        "showImageBlurSoldOutDesign": true,
        "timerData": _vm.timerData && _vm.timerData.showCountDown && _vm.saleDet && _vm.saleDet.enable_daily_drop_web ? _vm.timerData : null,
        "gstInClusiveLabel": _vm.bannerPlaceHolderForGstInclusiveLabel,
        "prm": prm,
        "wishlistItemsIDs": _vm.wishlistItemsIDs,
        "updateWishlist": _vm.updateWishlist,
        "hideWishlist": _vm.hideWishlist,
        "saleDet": _vm.saleDet,
        "callerComp": _vm.headingTitle ? _vm.headingTitle : 'PLP Page',
        "headingTitle": _vm.headingTitle
      },
      on: {
        "carousel-images-loaded": _vm.handleCarouselImagesLoaded
      },
      nativeOn: {
        "click": function($event) {
          _vm.productClick({
            prm: prm,
            index4: index4
          })
        }
      }
    })], 1)
  }), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "mt40 mb20 row w-full justify-content-center align-items-center load-more-loader"
  }, [_c('img', {
    staticClass: "spinner-3",
    attrs: {
      "src": _vm.staticImgServer + 'assets/spinner-3.gif',
      "alt": "Loader"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "scrollSentinelBottom",
    staticStyle: {
      "height": "1px",
      "width": "100%"
    }
  })], 2) : _c('div', [(this.$route.path === '/artists/now-or-never-sale') ? _c('div', {
    staticClass: "row justify-content-md-center justify-content-center",
    staticStyle: {
      "color": "#a79100",
      "font-size": "40px"
    }
  }, [_vm._v("Sale has ended")]) : _c('div', [(!_vm.productsListing.length && (this.$refs.filterOptions && this.$refs.filterOptions.getSelectedFilterChips && this.$refs.filterOptions.getSelectedFilterChips.length || this.showNotFound)) ? _c('div', {
    staticClass: "mtb20 no-product-list"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('NoProductFoundListing', {
    attrs: {
      "wishlistItemsIDs": _vm.wishlistItemsIDs,
      "updateWishlist": _vm.updateWishlist
    }
  })], 1)], 1) : _vm._e()])])])], 1)])])])]), _vm._v(" "), (_vm.isNotifyVisible) ? _c('exclusive-modal', {
    attrs: {
      "addExclusive": _vm.addExclusive,
      "togglePopup": _vm.togglePopup,
      "exclusiveAdded": _vm.exclusiveAdded,
      "removeExcFromCart": _vm.removeExcFromCart
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showCommonPopUp) ? _c('common-pop-up', {
    attrs: {
      "title": 'Download our mobile app',
      "txtArr": _vm.txtArr,
      "setPopup": _vm.hideCommonPopUp
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isCashbackPopup && _vm.messageHeadForAPPCashBack.text && _vm.messageListForAPPCashBack.length > 0) ? _c('common-msg-pop-up', {
    attrs: {
      "title": _vm.messageHeadForAPPCashBack.text,
      "txtArr": _vm.messageListForAPPCashBack,
      "setPopup": _vm.toggleCashbackPopup
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.isScrollToUpVisible) ? _c('div', {
    staticClass: "scroll-to-top-btn",
    class: _vm.$parent.isDesktop ? 'dkstickyfooter' : 'dkstickyNew',
    attrs: {
      "id": "scroll-to-top"
    }
  }, [(!_vm.$parent.isDesktop) ? _c('div', {
    staticClass: "text-white d-flex align-items-cener justify-content-center",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('span', {
    staticClass: "mobile-new-scrollTop px-2 py-1"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.2em",
      "line-height": "0"
    }
  }, [_vm._v("↑")]), _vm._v(" \n      " + _vm._s(_vm.formattedHeader) + " " + _vm._s(_vm.displayProductCount) + " / " + _vm._s(this.pagination && this.pagination.totalProduct) + "\n    ")])]) : _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-up"
  })])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6cee8452"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/listing.vue
// module id = 2574
// module chunks = 15